import React from 'react';
import '../less/main.less';
import clearBR from "../../../../helpers/utils/clearBR";

export default function template() {
    const {isMobile, page, data} = this.props;

  const items = data.map((item, index) => {
    const text = isMobile ? clearBR(this.l10n(item.text)) : this.l10n(item.text),
      title = isMobile ? clearBR(this.l10n(item.title)) : this.l10n(item.title);
        return (
          <div key={item.text} className={`${page}-item how-to-item ${item.index ? item.index : ''}`}>
            <div className="item-img-wrapper">
              <img src={item.img} alt={`img-${index}`}></img>
            </div>
            <div className='item-text-wrapper'>
              <div className="item-title" dangerouslySetInnerHTML={{ __html: title}}></div>
              <div className="item-text" dangerouslySetInnerHTML={{ __html: text}}></div>
            </div>
          </div>
        )
      });


    return (
        <div className={`${page}-wrapper how-to-block`}>
          <div className={`items-wrapper`}>{items}</div>
        </div>
    );
}
